const routes = {
    path: 'common',
    name: 'Common',
    childRoutes: [],
};

export default routes;
